import { FileStatus } from '@app/core/model/file-status';
import { FilterOption } from '@bssh/comp-lib/lib/components/data-table/custom-colDef';

/**
 * Status filter options for active-runs list, based on bssh AggregateRunState.
 * https://git.illumina.com/BaseSpace/basespace/blob/7d3282a66b55f21908b08b9381cf84d7897b84e5/src/Tang.Modules/seqHubUILibrary/bsEnumDictionary.ts#L70
 */
export const RUN_STATUS_FILTER_OPTIONS: FilterOption[] = [
    { filterValue: 'Analyzing', displayName: 'Analyzing' },
    { filterValue: 'Complete', displayName: 'Complete' },
    { filterValue: 'Failed', displayName: 'Failed' },
    { filterValue: 'FailedUpload', displayName: 'Failed Upload', },
    { filterValue: 'NeedsAttention', displayName: 'Needs Attention', },
    { filterValue: 'New', displayName: 'Planning' }, // Description for AggregateRunState.New is Planning
    { filterValue: 'Paused', displayName: 'Paused' },
    { filterValue: 'PendingAnalysis', displayName: 'Pending Analysis' },
    { filterValue: 'Ready', displayName: 'Ready' },
    { filterValue: 'Running', displayName: 'Running' },
    { filterValue: 'Stopped', displayName: 'Stopped' },
    { filterValue: 'Uploading', displayName: 'Uploading' },
    { filterValue: 'TimedOut', displayName: 'Timed Out' }
];

/**
 * Lane & QC Status filter options for active-runs list, for api filter param laneAndQcStatuses.
 * https://git.illumina.com/BaseSpace/basespace/blob/7d3282a66b55f21908b08b9381cf84d7897b84e5/src/Tang.Modules/seqHubUILibrary/bsEnumDictionary.ts#L91
 */
export const LANE_AND_QC_STATUS_FILTER_OPTIONS: FilterOption[] = [
    { filterValue: 'Initial', displayName: 'Initial' },
    { filterValue: 'QcPassed', displayName: 'QC Passed' },
    { filterValue: 'QcFailed', displayName: 'QC Failed' },
    { filterValue: 'LanePendingQc', displayName: 'Lane Pending QC' },
    { filterValue: 'LaneQcFailed', displayName: 'Lane QC Failed' },
    { filterValue: 'Rehybed', displayName: 'Rehybed' },
];

export const FILE_STATUS_FILTER_OPTIONS: FilterOption[] = [
    { filterValue: undefined, displayName: 'All' },
    { filterValue: FileStatus.ACTIVE, displayName: FileStatus.ACTIVE },
    { filterValue: FileStatus.EXTERNALLY_MODIFIED, displayName: FileStatus.EXTERNALLY_MODIFIED },
    { filterValue: FileStatus.ARCHIVED,  displayName: FileStatus.ARCHIVED },
    { filterValue: FileStatus.ARCHIVING,  displayName: FileStatus.ARCHIVING },
    { filterValue: FileStatus.UNARCHIVING,  displayName: FileStatus.UNARCHIVING },
    { filterValue: FileStatus.ZIPPED,  displayName: FileStatus.ZIPPED },
    { filterValue: FileStatus.ZIPPING,  displayName: FileStatus.ZIPPING},
    { filterValue: FileStatus.UNZIPPING,  displayName:FileStatus.UNZIPPING},
];
